import { Injectable, Injector } from "@angular/core";
import { environment } from "@environments/environment";
import { SystemParamValue } from "@interfaces/systemParamValue.interface";
import { Service } from "@services/service";
import { Observable } from "rxjs";

@Injectable()
export class SystemParameterService extends Service {
	constructor(injector: Injector) {
		super("SystemParams", injector);
	}

	// API
	getSystemParamValueById(id: number, vid: number) {
		return this.http.get(`${environment.server.apiURL}/${this.endpoint}/${id}/Values/${vid}`);
	}

	getSystemParamValuesById(id: number) {
		return this.http.get(`${environment.server.apiURL}/${this.endpoint}/${id}/Values`);
	}

	// Looks up a SystemParam by Name and returns its first SystemParamValue, parsed.
	getValueByName(name: string): Observable<any> {
		return new Observable((subscriber) => {
			this.getAll().subscribe(
				(res: any) => {
					const param = res.response.items.find((p: any) => p.name === name);
					if (param == null) { subscriber.error(new Error(`SystemParam '${name}' not found.`)); return; }
					this.getSystemParamValuesById(param.id).subscribe(
						(valRes: any) => {
							const first = valRes.response.items[0];
							if (first == null) { subscriber.error(new Error(`SystemParam '${name}' has no values.`)); return; }
							// The API can hand the value back already parsed; only a string needs JSON.parse.
							try { subscriber.next(typeof first.value === "string" ? JSON.parse(first.value) : first.value); subscriber.complete(); }
							catch (e) { subscriber.error(e); }
						},
						(err) => subscriber.error(err)
					);
				},
				(err) => subscriber.error(err)
			);
		});
	}

	updateSystemParamValueById(id: number, vid: number, data: SystemParamValue) {
		return this.http.patch(`${environment.server.apiURL}/${this.endpoint}/${id}/Values/${vid}`, data);
	}
}